import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { fieldGroupItemsStyle } from './FieldGroupItems.css';

type Props = ComponentPropsWithRef<'div'>;

export const FieldGroupItems = ({ children, ...delegated }: Props) => (
  <div {...delegated} className={clsx(fieldGroupItemsStyle, delegated.className)}>
    {children}
  </div>
);
